import { Link } from 'react-router-dom';

export default function NewsletterSection() {
  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
            订阅片多多影视资讯
          </h2>
          <p className="text-sm text-white/80 mb-6">
            第一时间获取最新影视上线通知、热门推荐和独家观影指南
          </p>
          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d9od11obdkpk99j7guj0"
            method="POST"
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              const honeypot = formData.get('phone_alt');
              if (honeypot && String(honeypot).trim() !== '') {
                alert('订阅成功！感谢您的关注。');
                return;
              }
              fetch(form.action, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
              })
                .then(async (res) => {
                  const text = await res.text();
                  return { ok: res.ok, text };
                })
                .then(({ ok, text }) => {
                  let serverMsg = '';
                  try {
                    const parsed = JSON.parse(text);
                    serverMsg = parsed?.meta?.message || parsed?.message || '';
                  } catch { /* ignore */ }
                  if (ok && (!serverMsg || !serverMsg.includes('spam'))) {
                    alert('订阅成功！感谢您的关注。');
                    form.reset();
                  } else {
                    alert(serverMsg || '订阅失败，请稍后再试');
                  }
                })
                .catch(() => alert('订阅失败，请检查网络后重试'));
            }}
          >
            <input
              type="email"
              name="email"
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3 text-sm bg-white/20 border border-white/30 rounded-full text-white placeholder:text-white/60 focus:outline-none focus:bg-white/30 focus:border-white/50 transition-all"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="website-alt-field"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-white text-primary-600 text-sm font-semibold rounded-full hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
          <p className="text-xs text-white/60 mt-4">
            我们尊重您的隐私，绝不会泄露您的邮箱地址
          </p>
        </div>
      </div>
    </section>
  );
}